export const BILLING_DIALOG_FOCUSABLE_SELECTOR = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "summary",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
].join(",");

export function focusBillingDialogElement(element) {
  if (!element || element.isConnected === false || typeof element.focus !== "function") return false;
  element.focus();
  return true;
}

export function handleBillingDialogKeyDown(event, {
  activeElement = null,
  blockingModalOpen = false,
  dialog = null,
  onClose = null,
} = {}) {
  if (!event || event.defaultPrevented || blockingModalOpen) return false;

  if (event.key === "Escape") {
    event.preventDefault?.();
    onClose?.();
    return true;
  }

  if (event.key !== "Tab" || !dialog) return false;
  const focusableElements = Array.from(dialog.querySelectorAll?.(BILLING_DIALOG_FOCUSABLE_SELECTOR) || [])
    .filter((element) => element.hidden !== true && element.getAttribute?.("aria-hidden") !== "true");
  if (!focusableElements.length) return false;

  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];
  const focusIsInside = typeof dialog.contains === "function" && dialog.contains(activeElement);
  const target = event.shiftKey
    ? (!focusIsInside || activeElement === first ? last : null)
    : (!focusIsInside || activeElement === last ? first : null);
  if (!target) return false;

  event.preventDefault?.();
  focusBillingDialogElement(target);
  return true;
}
